module.exports = __webpack_public_path__ + "img/BUI.e494c41d.png";